import type {ReactElement} from 'react';
import React from 'react';
import {DownloadGettyRequirementInfoBox} from '@Components/download-panel/components/download-getty-requirement-info-box/download-getty-requirement-info-box';
import {useDownloadPanelData} from '@Components/download-panel/download-panel.context';
import {Text, TextSize} from '@Components/text';
import styles from './download-panel-info-box.module.scss';
import {noop} from '@Utils/general.util';

interface DownloadPanelInfoBoxProps {
  onDownloadUpdatedDesignClick?: () => void;
}

export function DownloadPanelInfoBox({onDownloadUpdatedDesignClick = noop}: DownloadPanelInfoBoxProps): ReactElement | null {
  const {showOutdatedPosterInfoBox} = useDownloadPanelData();

  if (showOutdatedPosterInfoBox) {
    return (
      <div className={`_full-width spacing-p-t-2 text-center _fit-height spacing-p-b-2 spacing-p-r-3 spacing-p-l-3 radius-8 ${styles.container}`}>
        <Text
          onClick={(e): void => {
            const target = e.target as HTMLElement;
            if (target?.id === 'download-updated-text') {
              onDownloadUpdatedDesignClick();
            }
          }}
          dangerouslySetInnerHTML
          size={TextSize.XSMALL}
          val={window.i18next.t('pmwjs_outdated_design_information')}
        />
      </div>
    );
  }

  return <DownloadGettyRequirementInfoBox />;
}
